import formatNumber from './formatNumber';

export interface TForeignAmountFields {
  foreign_currency_code?: string | null;
  reference_rate?: string | null;
  expected_income_foreign?: string | null;
  foreign_lower?: string | null;
  foreign_upper?: string | null;
  received_income_foreign?: string | null;
  received_deviation_percent?: string | null;
}

const withThousands = (value: string) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatForeignAmount = (value: number | string) => withThousands(formatNumber(value, 0));

export const formatDeviationPercent = (value: number | string) =>
  `${Number(formatNumber(value, 2)).toString().replace('.', ',').replace('-', '−')} %`;

export const formatExpectedForeign = (order: TForeignAmountFields): string | undefined => {
  if (!order.foreign_currency_code || order.expected_income_foreign == null) return undefined;
  const corridor =
    order.foreign_lower != null && order.foreign_upper != null
      ? ` (${formatForeignAmount(order.foreign_lower)} – ${formatForeignAmount(order.foreign_upper)})`
      : '';
  return `≈ ${formatForeignAmount(order.expected_income_foreign)} ${order.foreign_currency_code}${corridor}`;
};

export const formatReceivedForeign = (order: TForeignAmountFields): string | undefined => {
  if (!order.foreign_currency_code || order.received_income_foreign == null) return undefined;
  const deviation =
    order.received_deviation_percent != null
      ? ` (${formatDeviationPercent(order.received_deviation_percent)})`
      : '';
  return `получено ${formatForeignAmount(order.received_income_foreign)} ${order.foreign_currency_code}${deviation}`;
};
